import { AfterViewInit, Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { CampaignPreviewComponent } from 'app/campaign/campaign-overview/campaign-preview/campaign-preview.component';

@Component({
  selector: 'app-snack',
  templateUrl: './snack.component.html',
  styleUrls: ['./snack.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SnackComponent implements AfterViewInit {
  @ViewChild(CdkPortalOutlet, { static: true }) portalOutlet!: CdkPortalOutlet;
  public properties;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private _snackRef: MatSnackBarRef<SnackComponent>,
  ) {
    this.properties = this.data;
  }

  ngAfterViewInit() {
    if (this.properties.action?.component) {
      this.createComponent();
    }
  }

  public closeSnack() {
    this._snackRef.dismiss();
  }

  private createComponent(): void {
    let component = this.properties.action.component;
    let inputProps = this.properties.action.properties;
    const portal = new ComponentPortal<CampaignPreviewComponent>(component);
    this.portalOutlet.detach();
    const componentRef = this.portalOutlet.attachComponentPortal(portal);
    for (const key in inputProps) {
      if (Object.prototype.hasOwnProperty.call(inputProps, key)) {
        componentRef.instance[key] = inputProps[key];
      }
    }
  }
}
